module.exports = __webpack_public_path__ + "assets/img/8731b0035d91344d5fb74c569625f1f7.png";